/**
 * Note: As defined in gemeenten.js
 */

const proxies = {
  '9001': [
    '0096', '0093', '0060', '0088',
  ],
  '9002': [
    '1723', '0744', '0784',
  ],
  '9003': [
    '1724', '1728', '0770', '0823', '1667',
  ],
  '9004': [
    '0757', '0845',
  ],
  '9005': [
    '0034', '0050', '0171', '0184', '0303', '0995',
  ],
  '9006': [
    '0888', '1954', '0889', '0893', '0899', '1711', '1903', '0907', '1729', '0917', '1507', '0928', '0882', '1640', '1641', '0935', '0938', '0944', '0946', '1894', '1669', '0957', '0965', '1883', '0971', '0981', '0994', '0983', '0984', '0986', '0988', '9006',
  ],
  '9007': [
    '1723', '1959', '0743', '0744', '1724', '0748', '1721', '0753', '1728', '0755', '0757', '0758', '1706', '0762', '0766', '1719', '0770', '0772', '0777', '0779', '1771', '1652', '0784', '0785', '0788', '1655', '1658', '0794', '0796', '0797', '0798', '1659', '0809', '1948', '1709', '0820', '0823', '0824', '0826', '0828', '1667', '1674', '0840', '0845', '0847', '0848', '0851', '0855', '0858', '0861', '0865', '0866', '0867', '0873', '0879', '1982', '1991', '9002', '9003', '9004', '9007',
  ],
  '9008': [
    '0106', '0109', '0114', '0118', '0119', '1680', '1681', '1690', '1699', '1701', '1730', '1731',
  ],
  '9009': [
    '0197', '0200', '0202', '0203', '0209', '0213', '0214', '0216', '0221', '0222', '0225', '0226', '0228', '0230', '0232', '0233', '0243', '0244', '0246', '0252', '0262', '0263', '0267', '0268', '0269', '0273', '0274', '0275', '0277', '0279', '0281', '0285', '0289', '0293', '0294', '0296', '0297', '0299', '0301', '0302', '0668', '1509', '1586', '1705', '1734', '1740', '1859', '1876', '1945', '1955', '1960',
  ],
  '9010': [
    '0358', '0361', '0362', '0373', '0375', '0376', '0377', '0383', '0384', '0385', '0388', '0392', '0394', '0396', '0397', '0399', '0400', '0402', '0405', '0406', '0415', '0417', '0420', '0431', '0432', '0437', '0439', '0441', '0448', '0450', '0451', '0453', '0473', '0479', '0498', '0532', '0852', '0880', '1598', '1696', '1911', '1942', '1980',
  ],
  '9011': [
    '0307', '0308', '0310', '0312', '0313', '0317', '0321', '0327', '0331', '0335', '0339', '0340', '0342', '0345', '0351', '0352', '0353', '0355', '0356', '0589', '0632', '0736', '1581', '1904', '1961',
  ],
  '9012': [
    '0141', '0147', '0148', '0150', '0153', '0158', '0160', '0163', '0164', '0166', '0168', '0173', '0175', '0177', '0180', '0183', '0189', '0193', '1700', '1708', '1735', '1742', '1773', '1774', '1896',
  ],
  '9013': [
    '0654', '0664', '0677', '0678', '0687', '0703', '0715', '0716', '0717', '0718', '1676', '1695', '1714',
  ],
  '9014': [
    '0482', '0484', '0489', '0501', '0502', '0503', '0505', '0512', '0513', '0518', '0523', '0530', '0531', '0534', '0537', '0542', '0546', '0547', '0553', '0556', '0569', '0575', '0579', '0590', '0597', '0599', '0603', '0606', '0610', '0613', '0614', '0622', '0626', '0627', '0629', '0637', '0638', '0642', '1525', '1621', '1783', '1842', '1884', '1892', '1901', '1916', '1924', '1926', '1930', '1931', '1963', '1978',
  ],
  '9015': [
    '0059', '0060', '0072', '0074', '0080', '0085', '0086', '0088', '0090', '0093', '0096', '0098', '0737', '1891', '1900', '1940', '1949', '1970',
  ],
  '9016': [
    '0014', '0037', '0047', '0765', '1895', '1950', '1952', '1966', '1969', '1979',
  ],
  '9017': [
    '0489', '0597', '0613',
  ],
  '9018': [
    '0034', '0050', '0171', '0184', '0303', '0307', '0308', '0310', '0312', '0313', '0317', '0321', '0327', '0331', '0335', '0339', '0340', '0342', '0345', '0351', '0352', '0353', '0355', '0356', '0358', '0361', '0362', '0373', '0375', '0376', '0377', '0383', '0384', '0385', '0388', '0392', '0394', '0396', '0397', '0399', '0400', '0402', '0405', '0406', '0415', '0417', '0420', '0431', '0432', '0437', '0439', '0441', '0448', '0450', '0451', '0453', '0473', '0479', '0498', '0532', '0589', '0632', '0736', '0852', '0880', '0995', '1581', '1598', '1696', '1904', '1911', '1942', '1961', '1980',
  ],
  '1982': [
    '1982', '1702', '0756',
  ],
  '9019': [
    '0613', '0484', '0505', '1924', '0531', '0534', '1931', '1621', '1916', '0553', '0556', '1842', '0569', '0590', '0597', '0606', '0610', '1525', '0622', '0627', '1783', '0637', '0642', '1695', '1676', '1714',
  ],
}

const vlaamsGewest = [
  '71066',
  '31005',
  '32011',
  '38008',
  '33011',
  '44021',
  '41082',
  '41018',
  '41018',
  '45064',
  '33021',
  '45064',
  '23045',
  '13029',
  '13037',
  '24104',
  '24054',
  '73028',
  '71053',
  '72043',
  '31022',
  '31043',
  '31005',
  '33041',
  '31003',
  '33039',
  '23003',
  '23025',
  '24066',
  '71053',
  '45065',
  '23002',
  '11002',
  '12014',
  '12014',
  '13035',
  '24086',
  '24109',
  '73042',
  '72020',
  '23003',
  '23096',
  '24020',
  '72042',
  '72021',
  '31040',
  '32003',
  '44021',
  '41048',
  '34013',
  '38016',
  '32006',
  '46021',
  '42006',
  '41048',
  '45064',
  '45068',
  '45061',
  '44083',
  '44064',
  '23027',
  '23099',
  '13049',
  '13053',
  '35014',
  '11038',
  '23064',
  '23047',
  '11002',
  '13036',
  '12005',
  '24134',
  '73042',
  '36010',
  '42028',
  '41063',
  '45065',
  '43007',
  '43014',
  '35011',
  '23077',
  '23003',
  '23047',
  '12014',
  '13010',
  '13014',
  '24020',
  '24059',
  '23047',
  '23096',
  '13012',
  '13040',
  '13035',
  '35029',
  '11021',
  '12040',
  '11055',
  '24062',
  '24062',
  '24045',
  '24014',
  '24001',
  '24011',
  '73001',
  '71004',
  '71004',
  '71017',
  '72037',
  '72038',
  '23016',
  '24130',
  '24028',
  '72039',
  '72018',
  '72041',
  '71002',
  '73109',
  '23002',
  '11002',
  '13004',
  '13046',
  '11057',
  '11004',
  '24094',
  '24059',
  '71070',
  '34042',
  '36011',
  '33039',
  '33039',
  '46021',
  '45068',
  '44064',
  '43010',
  '23009',
  '23104',
  '11052',
  '13014',
  '13021',
  '12025',
  '11040',
  '24062',
  '24001',
  '24066',
  '24137',
  '24054',
  '31004',
  '34022',
  '34022',
  '34041',
  '34003',
  '34040',
  '34040',
  '36006',
  '44021',
  '42011',
  '41002',
  '41011',
  '44085',
  '44085',
  '43014',
  '23101',
  '23097',
  '13016',
  '11054',
  '13025',
  '11044',
  '24086',
  '24055',
  '34002',
  '36012',
  '42025',
  '41034',
  '23077',
  '24062',
  '24054',
  '33039',
  '43018',
  '41027',
  '35005',
  '23038',
  '11002',
  '11016',
  '24055',
  '24066',
  '24107',
  '44084',
  '35011',
  '35006',
  '11001',
  '24009',
  '24043',
  '24041',
  '24137',
  '24059',
  '24028',
  '71016',
  '23033',
  '23100',
  '23097',
  '23102',
  '23096',
  '12009',
  '12029',
  '24007',
  '71002',
  '23094',
  '11002',
  '11002',
  '13014',
  '31012',
  '13003',
  '33039',
  '11013',
  '46021',
  '11022',
  '42010',
  '23062',
  '24094',
  '41048',
  '72042',
  '41063',
  '45068',
  '43014',
  '73109',
  '35011',
  '36007',
  '37020',
  '36008',
  '11002',
  '12025',
  '24038',
  '24055',
  '24001',
  '11054',
  '13053',
  '11053',
  '24062',
  '24137',
  '11004',
  '34003',
  '34040',
  '44021',
  '42008',
  '45068',
  '33011',
  '33040',
  '33029',
  '33037',
  '41027',
  '45063',
  '45060',
  '44083',
  '23050',
  '23094',
  '13010',
  '12002',
  '11002',
  '24086',
  '71024',
  '71004',
  '71011',
  '23003',
  '23081',
  '23025',
  '23103',
  '13011',
  '13014',
  '11029',
  '11037',
  '24094',
  '24109',
  '71037',
  '71067',
  '73098',
  '31005',
  '34013',
  '33016',
  '44085',
  '23064',
  '23086',
  '23086',
  '23060',
  '23105',
  '23096',
  '13035',
  '13002',
  '45063',
  '43002',
  '31042',
  '44021',
  '41048',
  '41011',
  '43002',
  '43007',
  '11025',
  '12035',
  '24009',
  '24135',
  '73109',
  '71034',
  '72030',
  '23027',
  '23044',
  '23025',
  '11002',
  '13044',
  '37017',
  '41011',
  '45059',
  '24054',
  '11002',
  '13013',
  '13019',
  '13001',
  '13006',
  '11035',
  '44013',
  '45059',
  '44084',
  '43010',
  '23027',
  '23077',
  '13031',
  '11024',
  '11002',
  '12041',
  '24008',
  '71020',
  '71045',
  '34022',
  '34027',
  '44021',
  '41081',
  '44081',
  '23086',
  '72003',
  '46025',
  '41024',
  '43014',
  '11039',
  '24048',
  '23098',
  '44021',
  '41048',
  '41002',
  '31006',
  '34003',
  '38002',
  '36019',
  '33011',
  '41002',
  '41048',
  '41027',
  '35002',
  '37011',
  '43005',
  '44019',
  '34042',
  '33021',
  '46024',
  '42023',
  '23064',
  '11050',
  '12025',
  '12007',
  '11009',
  '44052',
  '23003',
  '23016',
  '23088',
  '23088',
  '23050',
  '13023',
  '12021',
  '11018',
  '24014',
  '24008',
  '73098',
  '73022',
  '72038',
  '72004',
  '34022',
  '34023',
  '34042',
  '34042',
  '34043',
  '34040',
  '42026',
  '23025',
  '11002',
  '12014',
  '13003',
  '11030',
  '12041',
  '24134',
  '24133',
  '71004',
  '12035',
  '24086',
  '35013',
  '33021',
  '42004',
  '45063',
  '44085',
  '34009',
  '38014',
  '37020',
  '44084',
  '43002',
  '45035',
  '34002',
  '38002',
  '33011',
  '33011',
  '41002',
  '45062',
  '12025',
  '24086',
  '24033',
  '73098',
  '31005',
  '35011',
  '32030',
  '45041',
  '23052',
  '44021',
  '44021',
  '46020',
  '23064',
  '23039',
  '23094',
  '31040',
  '34042',
  '34002',
  '37002',
  '23016',
  '24135',
  '73109',
  '72043',
  '41024',
  '44020',
  '11054',
  '13014',
  '13017',
  '11008',
  '11023',
  '11002',
  '11002',
  '13008',
  '12026',
  '11002',
  '11005',
  '24134',
  '24020',
  '24016',
  '71053',
  '31043',
  '35011',
  '34003',
  '38025',
  '31033',
  '33039',
  '32010',
  '37010',
  '36015',
  '34025',
  '44021',
  '42003',
  '44085',
  '44085',
  '43010',
  '23016',
  '24043',
  '73107',
  '73107',
  '71017',
  '24041',
  '73109',
  '33039',
  '71034',
  '73066',
  '35029',
]

module.exports = {
  proxies,
  vlaamsGewest
}
